const DEFAULT_DESCRIPTION =
  "Tell us what campground you're looking for. We'll check the reservation website every 1-5 minutes and notify you if a spot opens up.";

// Search engines truncate snippets around ~160 chars. Trim to the last whole
// word (+ ellipsis) so we never emit a mid-word cut — applied centrally here so
// callers pass full copy and never re-implement the truncation.
export const META_DESCRIPTION_MAX = 160;

export function truncateDescription(text, max = META_DESCRIPTION_MAX) {
  if (!text || text.length <= max) return text;
  return text.slice(0, max).replace(/\s+\S*$/, "") + "...";
}

export function getSeoMeta({
  title,
  description = DEFAULT_DESCRIPTION,
  url,
  image,
  type = "website",
  publishedTime,
  modifiedTime,
  tags,
}) {
  const desc = truncateDescription(description);
  const meta = [
    { title },
    { name: "description", content: desc },
    { property: "og:type", content: type },
    { property: "og:title", content: title },
    { property: "og:description", content: desc },
    { property: "og:site_name", content: "Schnerp" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: desc },
  ];

  if (url) {
    meta.push({ tagName: "link", rel: "canonical", href: url });
    meta.push({ property: "og:url", content: url });
  }

  if (image) {
    meta.push({ property: "og:image", content: image });
    meta.push({ name: "twitter:image", content: image });
  }

  if (type === "article" && publishedTime) {
    meta.push({
      property: "article:published_time",
      content: publishedTime,
    });
  }

  if (type === "article" && modifiedTime) {
    meta.push({
      property: "article:modified_time",
      content: modifiedTime,
    });
  }

  if (type === "article" && tags?.length) {
    tags.forEach((tag) => {
      meta.push({ property: "article:tag", content: tag });
    });
  }

  return meta;
}

export function getBaseUrl(matches) {
  return matches?.[0]?.data?.env?.BASE_URL || "https://schnerp.com";
}

export function getDefaultOgImage(baseUrl) {
  return `${baseUrl}/logo/schnerp_symbol@4x.png`;
}
